
































































































import { Component } from "vue-property-decorator";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import { CONSOLE_SOUNDS } from "@/resources/constants/sounds";
import { TYPES_MESSAGES } from "@/resources/constants/messages";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import { ADMIN_SIDEBAR_OPTIONS } from "@/resources/constants/sidebarMenu";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "console-message-component",
})
export default class ConsoleMessageComponent extends mixins(UserValidator,Plans) {
  CONSOLE_SOUNDS = CONSOLE_SOUNDS;
  PLAN = PLAN;
  users = [0];
  sound = "NO_SOUND";
  message = "";
  loader = false;
  loading = false;
  userSelector = 0;
  isMultiSpace = false;
  get active(): boolean {
    return this.$store.getters["FloatMenuStore/getOpenConsoleMessage"];
  }
  set active(e: boolean) {
    this.$store.dispatch("FloatMenuStore/setOpenConsoleMessageAction", e);
  }
  mounted(): void {
    document.getElementById("textarea").focus();
    localStorage.removeItem("isCampus");
    localStorage.removeItem("progranNotificacionCampus");
  }
  get usersOnline(): Array<SpaceUserInterface> {
    return this.$store.getters["SpaceStore/getUsersInDraw"]
      .filter((a) => a.connectionStatus === "ONLINE")
      .sort((a, b) =>
        a.superSpaceUser.user.name
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .localeCompare(
            b.superSpaceUser.user.name
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
          )
      );
  }
  changeSelectUser(e: any): void {
    if (e.length > 1) {
      const index = e.indexOf(0);
      if (index === 0) e.splice(index, 1);
      else e.splice(0, index);
    }
  }
  changeSelectSpace(e: any): void {
    if (e.length > 1) {
      const index = e.indexOf(0);
      if (index === 0) e.splice(index, 1);
      else e.splice(0, index);
    }
  }
  onSelect(value: string): void {
    if (value !== "NO_SOUND") {
      const sound = this.CONSOLE_SOUNDS.filter((a) => a.name === value)[0].src;
      const audio = new Audio(sound);
      audio.autoplay = true;
      audio.play();
      setTimeout(() => {
        audio.pause();
      }, 5000);
    }
  }
  sendMessage(): void {
    if (this.isMultiSpace) this.sendMessageMultiSpace();
    else this.sendMessageSpace();
  }
  sendMessageSpace(): void {
    const users = this.users
      .filter((a) => a !== 0)
      .map((a) => {
        return { id: a };
      });
    const data = {
      message: this.message,
      type: "SPACE_MESSAGE",
      color: "BLUE",
      sound: this.sound,
      hasConfirmation: true,
      spaceUsers: users,
    };
    this.loading = true;
    this.$store.dispatch("SpaceStore/sendConsoleMessageAction", {
      spaceId: this.$store.getters["SpaceStore/getSpace"].id,
      data,
      callback: async () => {
        const space = this.$store.getters["SpaceStore/getSpace"];
        if (users.length <= 0 && space.isChatActive) {
          await this.$store.dispatch("ChatStore/sendSpaceMessageAction", {
            spaceId: space.id,
            data: {
              chatMessage: this.message,
              chatMessageType: TYPES_MESSAGES.ANNOUNCEMENT,
            },
          });
        }
        this.loading = false;
        this.message = "";
        this.users = [0];
      },
    });
  }
  sendMessageMultiSpace(): void {
    const data = {
      message: this.message,
      type: "SUPER_SPACE_MESSAGE",
      color: "BLUE",
      sound: this.sound,
      hasConfirmation: true,
    };
    this.loading = true;
    this.$store.dispatch("SpaceStore/sendConsoleMessageMultiSpaceAction", {
      superSpaceId: this.$store.getters["SpaceStore/getSpace"].superSpace.id,
      data,
      callback: async () => {
        this.loading = false;
        this.message = "";
        this.users = [0];
      },
    });
  }
  checkMultiSpace() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    return space.superSpace.isExpandable;
  }
  loadProgramNotification() {
    if (!this.activeOptionPlan(PLAN.SCHEDULE_ANNOUNCEMENT)) return;
    this.$store.dispatch("SpaceStore/setSelectedSpaceCustomizeAction", null);
    this.$store.dispatch("FloatMenuStore/setManageSpaceAction", true);
    this.$store.dispatch(
      "SystemStore/setManageSpaceMenuActiveAction",
      ADMIN_SIDEBAR_OPTIONS.ANNOUNCEMENTS
    );
    localStorage.setItem("isCampus", this.isMultiSpace ? "true" : "false");
    localStorage.setItem("open_modal_active", "active");
    this.active = false;
  }
}
